module.exports = __webpack_public_path__ + "img/conclusion3.8adf6fb6.svg";